import styled from "@emotion/styled"
import { Container, Dialog, IconButton, Typography } from "@mui/material"

export const CustomDialog = styled(Dialog)`
  .MuiPaper-root {
    border-radius: 32px;
    border: 1px solid rgba(1, 130, 98, 0.3);
    background: #f1f7f6;
    padding: 0.5rem;

    ${({ theme }) => theme.breakpoints.up("md")} {
      max-width: 859px !important;
      min-width: 859px !important;
      padding: 72px 100px;
    }
  }
`

export const CloseButton = styled(IconButton)`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 10px;
  right: 10px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    top: 0;
    right: 0;
    width: 70px;
    height: 70px;
  }
`

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.tertiary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(32)};
  font-style: normal;
  font-weight: 550;
  line-height: ${({ theme }) => theme.typography.pxToRem(40)};
  letter-spacing: 0.16px;
  text-align: center;
  max-width: 675px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    line-height: ${({ theme }) => theme.typography.pxToRem(32)};
    margin-top: 2rem;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.8;
  text-align: center;
  max-width: 559px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(56)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    line-height: ${({ theme }) => theme.typography.pxToRem(22)};
    margin-bottom: 2rem;
  }
`

export const ScanDescription = styled(Typography)`
  color: #004332;
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  opacity: 0.4;
`

export const DownloadContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.typography.pxToRem(32)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    margin-bottom: 2rem;
  }
`

export const ButtonsContainer = styled.div``

export const QrContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DownloadButton = styled(IconButton)`
  border-radius: 14.4px;
  border: 0.6px solid ${({ theme }) => theme.palette.primary.main};
  display: flex;
  padding: 21.6px 24px;
  justify-content: center;
  align-items: center;
  column-gap: 1rem;
  margin-top: 1rem;
`
